module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/dl_google-cbc462d044645cacac4450f0b1d93676.png";